export default "__VITE_ASSET__CT_sgtsN__"